import { Company } from "../../types/Company";
import { get } from "./authenticatedrequestUtil";

export const getCompany = get<Company>(
  ({ companyId }) => `${companyId}/company/`
);
